import { alpha } from '@mui/material/styles';
import { tabClasses } from '@mui/material/Tab';
// ----------------------------------------------------------------------
export function tabs(theme) {
    return {
        MuiTabs: {
            styleOverrides: {
                root: {
                    backgroundColor: theme.palette.background.paper,
                    borderRadius: '56px',
                    border: `1px solid #919EAB1F`,
                    padding: theme.spacing(0.5),
                    minHeight: 'auto',
                    width: 'fit-content',
                },
                indicator: {
                    display: 'none',
                },
                flexContainer: {
                    gap: theme.spacing(0.5),
                },
                scrollButtons: {
                    width: 48,
                    borderRadius: '50%',
                },
            },
        },
        MuiTab: {
            styleOverrides: {
                root: {
                    padding: theme.spacing(0.75, 2),
                    opacity: 1,
                    minWidth: 48,
                    minHeight: 36,
                    fontWeight: theme.typography.fontWeightSemiBold,
                    color: theme.palette.text.secondary,
                    border: 'none',
                    borderRadius: '50px',
                    textTransform: 'none',
                    transition: 'all 0.2s ease-in-out',
                    '&.Mui-selected': {
                        color: theme.palette.primary.darker,
                        backgroundColor: alpha(theme.palette.primary.main, 0.08),
                    },
                    '&:not(:last-of-type)': {
                        marginRight: 0,
                    },
                    [`&:not(.${tabClasses.selected})`]: {
                        color: theme.palette.text.secondary,
                    },
                },
            },
        },
    };
}
